// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3lSrJ","fullView":"styles_fullView__3j1VC"};